module.exports = __webpack_public_path__ + "assets/img/f59234bda633f53fb2f97ad07893a5ab.svg";